import { useMemo } from 'react';
const usePointerState = (localWindow = (typeof window === 'undefined'
    ? undefined
    : window)) => (useMemo(() => {
    if (!localWindow) {
        // Default to 'NON-TOUCH' for SSR
        return 'NON-TOUCH';
    }
    return ((localWindow
        .matchMedia('(hover: none)')
        .matches)
        || (localWindow
            .matchMedia('(pointer: coarse)')
            .matches)
        ? 'TOUCH'
        : 'NON-TOUCH');
}, [
    localWindow,
]));
export { usePointerState };
